import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { AudienceDetailPage } from '@/components/audiences/audience-detail/audience-detail-page';
import { loadNamespaces } from '@/lib/i18n/i18n';

const paramSchema = z.object({ audienceId: z.string().uuid() });

export const Route = createFileRoute('/_authenticated/audiences/$audienceId')({
  loader: () => loadNamespaces('audiences'),
  staticData: { title: 'route.audience_detail.title' },
  parseParams: (params) => paramSchema.parse(params),
  component: AudienceDetailRoute,
});

function AudienceDetailRoute(): React.ReactElement {
  const { audienceId } = Route.useParams();
  return <AudienceDetailPage audienceId={audienceId} />;
}
